'use strict';

const Reflux = require('@muzzylane/reflux');

const ResetPasswordActions = require('../actions/reset_password_actions');
const ServerRequest = require('../actions/request');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');
const SignInActions = require('../actions/sign_in_actions');

let initialized = false;
let action = {};

const RegisterStore = Reflux.createStore({
    listenables: [ResetPasswordActions, SignInActions],
    init: function() {},
    
    resetState: function() {},
    
    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },

    getState: function() {
        return {
            action: action,
        }
    },

    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
    },

    onRequestResetCompleted: function(actionId, res) {
        //console.log("onRequestResetCompleted:", actionId, res);
        action = {
            id: actionId,
            message: 'An email has been sent containing a link to reset your password.',
        };

        this.emitStatus();
    },

    onRequestResetFailed: function(actionId, err) {
        console.warn("onRequestResetFailed:", actionId, err);
        action = { id: actionId };

        if (err.status) {
            switch (err.status) {
                case 422:
                    action.error = new ForgeError({ message: ErrorConsts.EMAIL_NOT_REGISTERED });
                    break;
                case 400:
                    action.error = new ForgeError({ message: ErrorConsts.EMAIL_INVALID, uiRefs: ["email"] });
                    break;
                case 409: // use server response as error message unless undefined
                    action.error = new ForgeError({ message: err.responseText || ErrorConsts.INTERNAL_GENERAL });
                    break;
                default:
                    action.error = new ForgeError({ message: ErrorConsts.INTERNAL_GENERAL });
            }
        }
        else {
            action.error = err;
        }

        this.emitStatus();
    },

    onResetPasswordCompleted: function(actionID, res) {
        //console.log("onResetPasswordCompleted ", actionID, res);
        action = {};
        action.id = actionID;
        action.message = 'Your password has been changed.';

        this.emitStatus();
    },

    onResetPasswordFailed: function(actionID, err) {
        console.warn("onResetPasswordFailed ", actionID, err);
        action = {};
        action.id = actionID;

        if (err.status) {
            switch (err.status) {
                case 403:
                case 422:
                    action.error = err;
                    break;
                default:
                    action.error = new ForgeError({message: ErrorConsts.INTERNAL_GENERAL});
            }
        }
        else {
            action.error = err;
        }

        this.emitStatus();
    }
});

module.exports = RegisterStore;
